import { ListTableColumn, createListTableColumns, renderDateTime } from "sprint-common-web";

import { getAirlineDetailsDashboardHref } from "../../../AdminRoutes";
import { AirlineListItem } from "./AirlineListItem";

export const createAirlineListingColumns = (): ListTableColumn<AirlineListItem>[] => {
    return createListTableColumns<AirlineListItem>([
        {
            type: "link",
            key: "name",
            name: "Name",
            minWidth: 200,
            maxWidth: 380,
            isSortable: true,
            getHref: (item) => getAirlineDetailsDashboardHref(item.id)
        },
        {
            type: "basic",
            key: "code",
            name: "Code",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true
        },
        {
            type: "basic",
            key: "buzzId",
            name: "Buzz",
            minWidth: 100,
            maxWidth: 280,
            isSortable: false
        },
        {
            type: "basic",
            key: "shreqId",
            name: "Shreq",
            minWidth: 100,
            maxWidth: 280,
            isSortable: false
        },
        {
            type: "basic",
            key: "updatedDate",
            name: "Updated",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true,
            onRender: renderDateTime
        }
    ]);
};
